import { HOST, ORG_ID } from 'config';
import React, {
  createContext, useContext, useEffect, useState,
} from 'react';
import { Loading } from 'react-admin';
import authProvider, { authTokenKey } from './authProvider';

const OrgContext = createContext();

function OrgProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const [organization, setOrganization] = useState(null);

  useEffect(() => {
    const fetchOrganization = async () => {
      if (ORG_ID) {
        setLoading(true);
        const token = localStorage.getItem(authTokenKey);
        fetch(`${HOST}/org/${ORG_ID}`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
          .then((res) => {
            if (!res.ok) {
              if (res.status === 401 && authProvider.isLoggedIn()) {
                authProvider.logout();
                window.location.reload();
              }
              throw new Error(`HTTP error! Status: ${res.status}`);
            }
            return res.json();
          })
          .then(({ data: org }) => {
            setOrganization(org);
            document.title = `Admin - ${org.title}`;
          })
          .catch((err) => {
            console.log('Error fetching organization:', err);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    };

    fetchOrganization();
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <OrgContext.Provider value={organization}>
      {children}
    </OrgContext.Provider>
  );
}

OrgProvider.useOrg = () => {
  const org = useContext(OrgContext);
  return org;
};

export default OrgProvider;
